// Firebase web app of project woodpecker-5c732 (Firebase console → Project
// settings → Your apps → Web). Public identifiers, not secrets: they ship in
// every browser bundle; access is controlled by Firebase/Google, not by these.
export const firebaseConfig = {
  apiKey: "AIzaSyBDqoPToFr7nQlkRKkhTW2psKyoS7x6Xdw",
  authDomain: "woodpecker-5c732.firebaseapp.com",
  projectId: "woodpecker-5c732",
  storageBucket: "woodpecker-5c732.firebasestorage.app",
  messagingSenderId: "814931993557",
  appId: "1:814931993557:web:2a1c5b2cd835e32992d35c",
  measurementId: "G-M0DD63HW0N",
} as const;
